// these CSS requires need to come first so component css can override shared css without needing !important
require('@alltrails/maps/sharedCss.css');
require('@alltrails/modules/PhotoUpload/sharedCss.css');
require('@alltrails/modules/ActivityUpload/sharedCss.css');
require('@alltrails/shared/sharedCss.css');
/* eslint-disable import/first */
import ContributeTrailApp from 'react_components/contribute/ContributeTrailApp';
import { Converter } from 'react_components/converter/converter';
import { ConverterSuccess } from 'react_components/converter/converter_success';
import AdaChatbot from '@alltrails/shared/components/AdaChatbot';
import DeleteAccountButtons from 'components/DeleteAccountButtons';
import DeleteAccountContent from 'components/DeleteAccountContent';
import FiveHundred from 'pages/errors/FiveHundred';
import FooterWrapper from 'components/FooterWrapper';
import FourOFour from 'pages/errors/FourOFour';
import LegacyMap404 from 'pages/errors/LegacyMap404';
import Terms from 'pages/Terms/Terms';
import TermsPrevious from 'pages/Terms/TermsPrevious';
import GeneralPrivacyPolicy from 'components/privacyPolicy/GeneralPrivacyPolicy';
import GlobalActions from 'components/GlobalActions';
import NavBar from 'components/NavBar';
import ResetPassword from 'pages/ResetPassword';
import PrintPage from 'components/PrintPage';
import QuoteRotator from 'components/QuoteRotator';
import ReferralRouter from 'components/ReferralRouter';
import Refer from 'components/Refer';
import SearchApp from 'components/SearchApp';
import SidebarTrailResultListWrapper from 'components/SidebarTrailResultListWrapper';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ReactRailsUJS = require('react_ujs');

const context = {
  AdaChatbot,
  ContributeTrailApp,
  Converter,
  ConverterSuccess,
  DeleteAccountButtons,
  DeleteAccountContent,
  FiveHundred,
  FooterWrapper,
  FourOFour,
  LegacyMap404,
  GeneralPrivacyPolicy,
  GlobalActions,
  NavBar,
  ResetPassword,
  PrintPage,
  QuoteRotator,
  ReferralRouter,
  Refer,
  SearchApp,
  SidebarTrailResultListWrapper,
  Terms,
  TermsPrevious
};

ReactRailsUJS.getConstructor = className => context[className];
